import ConnectorMapping from './ConnectorMapping'
import ConnectorViewMappingStore from './context/context'

const ConnectorViewMapping = () => {
  return (
    <ConnectorViewMappingStore>
      <ConnectorMapping />
    </ConnectorViewMappingStore>
  )
}

export default ConnectorViewMapping
